import {
    MediaItem,
    VideoItem,
    TestimonialItem,
    AvatarsOnlyItem,
    TestimonialDataItem,
} from './testimonial.types';

export const isMediaItem = (item: TestimonialDataItem): item is MediaItem => {
    return item.type === 'media';
};

export const isVideoItem = (item: TestimonialDataItem): item is VideoItem => {
    return item.type === 'video';
};

export const isTestimonialItem = (item: TestimonialDataItem): item is TestimonialItem => {
    return item.type === 'testimonial';
};

export const isAvatarsOnlyItem = (item: TestimonialDataItem): item is AvatarsOnlyItem => {
    return item.type === 'avatars-only';
};
